// Lightbox.jsx                модалка

import React from 'react';
import PropTypes from 'prop-types';
import ImageViewer from './ImageViewer';
import VideoViewer from './VideoViewer';
import PdfViewer from './PdfViewer';

export default function Lightbox({ images = [], videos = [], pdfs = [], lb }) {
    const { current, close, prev, next, zoomOut, zoomIn, zoom100, zoomFit } = lb;

    if (!current) return null;
    let list = current.kind === 'image' ? images : current.kind === 'video' ? videos : pdfs;
    const active = list?.[current.index] ?? null;
    if (!active) return null;

    return (
        <div
            className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center p-4"
            onClick={(e) => e.target === e.currentTarget && close()}
        >
            <div className="relative select-none">
                {/* 🔹 Кнопка закриття (аналог ESC) — ПОКАЗУЄМО тільки на мобільних */}
                <button
                    type="button"
                    className="md:hidden absolute text-sm px-3 py-1.5 rounded-full hover:bg-white/20"
                    onClick={(e) => {
                        e.stopPropagation();
                        close();
                    }}
                >
                    ✕ Закрити
                </button>

                {/* 🔹 Верхні кнопки керування зумом — ТІЛЬКИ НА ДЕСКТОПІ (md+) */}
                {lb.current.kind === 'image' && (
                    <div className="hidden md:flex absolute -top-12 right-0 items-center gap-2 text-white/90">
                        <button
                            onClick={zoomOut}
                            className="text-sm px-3 py-1.5 rounded-full bg-white/10 border border-white/20"
                        >
                            −
                        </button>
                        <button
                            onClick={zoomIn}
                            className="text-sm px-3 py-1.5 rounded-full bg-white/10 border border-white/20"
                        >
                            +
                        </button>
                        <button
                            onClick={zoom100}
                            className="text-sm px-3 py-1.5 rounded-full bg-white/10 border border-white/20"
                        >
                            100%
                        </button>
                        <button
                            onClick={zoomFit}
                            className="text-sm px-3 py-1.5 rounded-full bg-white/10 border border-white/20"
                        >
                            Fit
                        </button>
                    </div>
                )}

                {current.kind === 'image' && <ImageViewer item={active} lb={lb} />}
                {current.kind === 'video' &&
                    <VideoViewer
                        item={active}
                        onPrev={lb.prev}
                        onNext={lb.next}
                    />}
                {current.kind === 'pdf' && <PdfViewer item={active} lb={lb} />}

                {list.length > 1 && (
                    <>
                        {/* 🔹 Кнопки навігації ← → — тільки на md+ (на мобільних приховані) */}
                        <button
                            className="hidden md:flex items-center justify-center absolute left-0 top-1/2 -translate-y-1/2 px-3 py-2 bg-white/10 text-white rounded-r-xl border border-white/20"
                            onClick={(e) => {
                                e.stopPropagation();
                                prev();
                            }}
                        >
                            ←
                        </button>
                        <button
                            className="hidden md:flex items-center justify-center absolute right-0 top-1/2 -translate-y-1/2 px-3 py-2 bg-white/10 text-white rounded-l-xl border border-white/20"
                            onClick={(e) => {
                                e.stopPropagation();
                                next();
                            }}
                        >
                            →
                        </button>
                    </>
                )}
            </div>
        </div>
    );
}

Lightbox.propTypes = {
    images: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string,
        thumb: PropTypes.string,
        url: PropTypes.string,
    })),
    videos: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string,
        thumb: PropTypes.string,
        url: PropTypes.string,
    })),
    pdfs: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string,
        thumb: PropTypes.string,
        url: PropTypes.string,
    })),
    lb: PropTypes.object.isRequired,
};
